












































import {Component, Vue, Watch} from 'vue-property-decorator';
import Password from './Password.vue';
import ErrorGroup from './ErrorGroup.vue';
import ForgotLinks from './ForgotLinks.vue';
import {Action, Mutation, State} from 'vuex-class';
import {EmailStatus} from '../EmailStatus';

@Component({
  components: {
    Password,
    ErrorGroup,
    ForgotLinks,
  },
})
export default class Login extends Vue {
  protected email: string = localStorage.getItem('email') || '';
  protected password: string = '';
  protected buttonText: string = 'Continue to sign in';
  protected okClicked: boolean = false;
  protected isValidEmail: boolean = !!localStorage.getItem('email');
  protected origin: string = process.env.VUE_APP_ROOT_API;
  protected isPrestineEmail: boolean = true;

  @Action('emailSubmit') protected emailSubmitAction: any;
  @Mutation('EMAIL_CLEAR_ERROR') protected clearErrorMutation: any;
  @Mutation('CLEAR_LOGIN_ERROR') protected clearPasswordMutation: any;
  @Action('loginSubmit') protected loginSubmitAction: any;
  @State('status') protected status?: EmailStatus;
  @State('showPasswordError') protected showPasswordError?: boolean;

  get emailValid() {
    return this.status === 'not-tested' || this.status === 'no-match';
  }

  protected handleClick() {
    if (this.ifFmi()) {
      return;
    }
    this.$validator.validateAll().then(val => {
      if (val) {
        this.buttonText = 'Login';
        this.emailSubmitAction({email: this.email});
      }
    });
  }

  protected handleSubmit() {
    if (this.ifFmi() || this.password === '') {
      return;
    }
    this.loginSubmitAction({
      email: this.email,
      password: this.password,
      returnUrl: encodeURIComponent(this.$route.query.ReturnUrl as string),
    });
  }

  private ifFmi() {
    return this.email.toLowerCase().indexOf('@fmi.') > -1 || this.email.toLowerCase().indexOf('@bidvestlife.') > -1;
  }

  @Watch('email')
  private onModelChanged(value: string, oldValue: string) {
    this.isPrestineEmail = false;
    this.clearPasswordMutation();
    this.clearErrorMutation();
    this.$validator.validate().then(result => {
      this.isValidEmail = result;
      if (this.ifFmi()) {
        localStorage.setItem(
          'email',
          this.email.substring(0, this.email.length - 1),
        );
        (this.$refs.externalLogin as any).submit();
      }
    });
  }

  @Watch('password')
  private onModelChangedPassword(value: string, oldValue: string) {
    this.clearPasswordMutation();
  }
}
